
export default function Header({title}) {
  return(
    <div style={{backgroundColor: '#061953', width: '100%', borderRadius: 5, marginBottom: 10, height:60, alignItems: 'center', display: 'flex', justifyContent: 'center'}}>
      <h1 style={{color: '#f0f0f0', fontSize: 24, textAlign: 'center', width: '100%'}}>
        {title}
      </h1>
    </div>
  )
}

